/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// the same code from the theme.js but without the vimeo part for the background-video since it wasn't working. Also called it when the doc loads
class YouTubeBackgroundVideoSection {
  constructor(container) {
    this.element = container;
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

    this._loadScript().then(this._setupPlayer.bind(this));
  }

  _loadScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = '//www.youtube.com/iframe_api';
    });
  }

  onUnload() {
    if (this.player) {
      this.player.destroy();
    }
  }

  _setupPlayer() {
    const elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');
    const playerLoadingInterval = setInterval(() => {
      if (window.YT) {
        this.player = new YT.Player(elementToInsert, {
          videoId: this.options['videoId'],
          playerVars: {
            showinfo: 0,
            controls: 0,
            autohide: 1,
            fs: 0,
            rel: 0,
            height: '100%',
            width: '100%',
            iv_load_policy: 3,
            html5: 1,
            loop: 1,
            playsinline: 1,
            modestbranding: 1,
            disablekb: 1,
            origin: this.options['requestHost']
          },
          events: {
            onReady: this._onYouTubeReady.bind(this),
            onStateChange: this._onYouTubeStateChange.bind(this)
          }
        });
        clearInterval(playerLoadingInterval);
      }
    }, 50);
  }

  _onYouTubeReady(event) {
    this.player.mute();
    this.player.playVideo();
  }

  _onYouTubeStateChange(event) {
    if (event.data === YT.PlayerState.ENDED) {
      this.player.playVideo();
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const videoSectionElement = document.querySelector('[data-section-type="youtube-background-video"]');
  if (videoSectionElement) {
    const youtubeBackgroundVideoSection = new YouTubeBackgroundVideoSection(videoSectionElement);
  }
});


// product carrousel using slick and fix for offsetHeight error
window.onload = function() {
  var headerElement = document.getElementById('section-header') || document.getElementById('shopify-section-header');
  
  if (headerElement) {
      const headerHeight = headerElement.offsetHeight;
      const slideshowContainer = document.querySelector('.slideshowContainer');
      if (slideshowContainer) {
        slideshowContainer.style.marginTop = (headerHeight - 15) + 'px';
      }
  }
};

document.addEventListener("DOMContentLoaded", function() {
    if (typeof $ !== 'undefined') {
        $('.slides-wrapper').slick({
            slidesToScroll: 1,
            draggable: true,
            dots: false,
            prevArrow: false,
            nextArrow: false,
            infinite: true,
            centerMode: true,
            slidesToShow: 1,
            centerPadding: '400px',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        centerPadding: '300px',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        centerPadding: '150px',
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        centerPadding: '100px',
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        centerPadding: '50px',
                    }
                }
            ]
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    var slideshows = document.querySelectorAll('.Slideshow__Carousel');
    
    slideshows.forEach(function(slider) {
      if (window.Flickity && window.lazySizes) {
        var flkty = Flickity.data(slider);
        
        if (flkty) {
          var forceUnveil = function() {
            var activeSlide = flkty.selectedElement;
            if (activeSlide) {
              var images = activeSlide.querySelectorAll('.Slideshow__Image');
              images.forEach(function(img) {
                if (img.classList.contains('Image--lazyLoad') || img.classList.contains('Image--lazyLoading')) {
                   window.lazySizes.loader.unveil(img);
                }
              });
            }
          };

          flkty.on('select', forceUnveil);
          
          forceUnveil();
        }
      }
    });
  }, 100);
});




